// src/pages/reasoning/ReasoningPractice.tsx
import { Practice } from "@/components/Practice";

export function ReasoningPractice() {
  return (
    <Practice
      endpoint="/api/reasoning/random"
      sessionType="reasoning"
      title="Reasoning Practice"
    />
  );
}
